import { createWebHashHistory, createRouter } from "vue-router";
import { BRANG_ENUM } from "@/views/config.js";
const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  {
    path: "/",
    name: "layout",
    component: () => import("../components/layout/index.vue"),
    children: [
      {
        path: "home",
        name: "home",
        component: () => import("../views/home/index.vue"),
        meta: {
          title: "首页",
        },
      },
      {
        path: "introduce",
        name: "introduce",
        component: () => import("../views/introduce/index.vue"),
        meta: {
          title: "企业简介",
        },
      },

      {
        path: "news",
        name: "news",
        component: () => import("../views/news/index.vue"),
        meta: {
          title: "新闻资讯",
        },
      },
      {
        path: "join",
        name: "join",
        component: () => import("../views/join/index.vue"),
        meta: {
          title: "加入我们",
        },
      },
      {
        path: "about",
        name: "about",
        component: () => import("../views/about/index.vue"),
        meta: {
          title: "联系我们",
        },
      },
      ...BRANG_ENUM.map((x) => {
        return {
          path: `brand${x.value}`,
          name: `brand${x.value}`,
          component: () => import("../views/brand/index.vue"),
          meta: {
            title: x.label,
          },
        };
      }),
    ],
  },
  // {
  //     path: '*',
  //     redirect: '/404'
  // },
  // {
  //     path: '/403',
  //     component: () => import(/* webpackChunkName: "403" */ '../components/403.vue'),
  //     meta: {
  //         title: '403'
  //     }
  // },
  // {
  //     path: '/404',
  //     component: () => import(/* webpackChunkName: "404" */ '../components/404.vue'),
  //     meta: {
  //         title: '404'
  //     }
  // }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
